import { DocxViewerPreview } from './extend-ui/ui/docx-viewer';

export function DocxArtifactPreview({
  fitToPaneRequestId,
  onUserZoomChange,
  sourceUrl,
  title,
}: {
  fitToPaneRequestId?: number;
  onUserZoomChange?: () => void;
  sourceUrl: string;
  title: string;
}) {
  return (
    <DocxViewerPreview
      className="h-full min-h-[480px]"
      defaultZoom={100}
      fitToPaneRequestId={fitToPaneRequestId}
      fileName={title}
      forceInlineThumbnailSidebar
      isDark={false}
      onIsDarkChange={() => undefined}
      onUserZoomChange={onUserZoomChange}
      showActionsMenu={false}
      showToolbar
      showUpload={false}
      src={sourceUrl}
    />
  );
}
